import React, { useState, useEffect, useRef  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../../css/form.css';
import '../../../../css/InventoryReport.css';
import { API } from "../../../../services/api";
import { useReactToPrint } from 'react-to-print';
import logo from '../../../../img/logo/ManeeCafeLogo.jpg';
import DatePicker from "react-datepicker";
import axios from "axios";
axios.defaults.baseURL = API;

class PrintReport extends React.PureComponent {
  render() {
      function currencyFormat(num) {
          if (num !== "") {
              return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
          }
      }
      const billDetails = this.props.BillDetails;
      const productList = this.props.TemProductList;
      let i =0;
      let TotalQTY =0;
      let subtotal =0;
      const StartDate = (new Intl.DateTimeFormat('en-US', {day: '2-digit', month: '2-digit',year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(billDetails.StartedDate));
      const EndDate = (new Intl.DateTimeFormat('en-US', {day: '2-digit', month: '2-digit',year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(billDetails.EndedDate));
      return (
            <div className="InventoryReportContent">
                <div className="ReportHeader">
                  <div className="ReportHeaderBody">
                      <img className="profile-img" src={logo} />
                      <div className="ReportTitle">
                        <div className="titleHeader1">
                          <span>ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</span>
                        </div>
                        <div className="titleHeader2">
                            <span>ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ</span>
                        </div>
                        <div className="titleHeader2">
                            <span>**********</span>
                        </div>
                        <div className="titleHeader3">
                            <span>ລາຍງານ ຮ້ານເບີກເຄື່ອງ</span>
                      </div>
                    </div>
                  </div>
                  <div className="ReportBillNo">
                      <span>ແຕ່ວັນທີ # {StartDate}</span>
                    </div>
                    <div className="PrintDate">
                        <span>ຫາວັນທີ: {EndDate}</span> 
                    </div>
                    <div className="ReportLocation">
                        <span>ສາຂາ: {billDetails.LocationName}</span>
                    </div>
                </div>
                <div className="ReportBody">
                    <div className="ReportBodyHeader">
                        <span className="CountNumber">NO.</span>
                        <span className="Barcode">Barcode</span>
                        <span className="ProductType">ປະເພດສິນຄ້າ</span>
                        <span className="Category">ໝວດສິນຄ້າ</span>
                        <span className="Brand">ຫຍີ່ຫໍ້</span>
                        <span className="SizeType">Size Type</span>
                        <span className="Size">ຂະໜາດ</span>
                        <span className="Retail_Price">ລາຄາ</span>
                    </div>
                    <div className="HeadLine">
                      <div className="footer-line"/>
                    </div>
                    <div className="ReportDetail">
                        {
                            productList && productList.map((x, y) => {
                              TotalQTY = Number(TotalQTY) + Number(x.Quantity);
                              subtotal = Number(subtotal) + (Number(x.Retail_Price) * Number(x.Quantity));
                              if(y < 18){
                                return (
                                  <div className="Items">
                                      <div className="Detail">
                                          <div className="mds">
                                              <span className="NO">{(y + 1) }</span>
                                              <span className="Barcode">{x.Barcode.length > 20 ? x.Barcode.substring(0, 20) + '...' : x.Barcode}</span>
                                              <span className="ProductType">{x.ProductType.length > 25 ? x.ProductType.substring(0, 25) + '...' : x.ProductType}</span>
                                              <span className="Category">{x.Category.length > 25 ? x.Category.substring(0, 25) + '...' : x.Category}</span>
                                              <span className="Brand">{x.Brand.length > 12 ? x.Brand.substring(0, 12) + '...' : x.Brand}</span>
                                              <span className="SizeType">{x.SizeType.length > 10 ? x.SizeType.substring(0, 10) + '...' : x.SizeType}</span>
                                              <span className="Size">{x.Size}</span>
                                              <span className="Retail_Price">{currencyFormat(x.Retail_Price)}</span>
                                          </div>
                                          <div className="ProductName">
                                              <span className="LaoName">{x.LaoName}</span>
                                              <span className="Quantity">{" (ຈຳນວນ " + x.Quantity + ")"}</span>
                                          </div>
                                          <div className="p-line"/>
                                      </div>
                                  </div>
                                )
                              } else if (i == 0) {
                                i++;
                                return (
                                  <div className="Items">
                                      <div className="Detail">
                                      <div className="newline"></div>
                                            <div className="mds">
                                              <span className="NO">{(y + 1) }</span>
                                              <span className="Barcode">{x.Barcode.length > 20 ? x.Barcode.substring(0, 20) + '...' : x.Barcode}</span>
                                              <span className="ProductType">{x.ProductType.length > 25 ? x.ProductType.substring(0, 25) + '...' : x.ProductType}</span>
                                              <span className="Category">{x.Category.length > 25 ? x.Category.substring(0, 25) + '...' : x.Category}</span>
                                              <span className="Brand">{x.Brand.length > 12 ? x.Brand.substring(0, 12) + '...' : x.Brand}</span>
                                              <span className="SizeType">{x.SizeType}</span>
                                              <span className="Size">{x.Size}</span>
                                              <span className="Retail_Price">{currencyFormat(x.Retail_Price)}</span>
                                          </div>
                                          <div className="ProductName">
                                              <span className="LaoName">{x.LaoName}</span>
                                              <span className="Quantity">{" (ຈຳນວນ " + x.Quantity + ")"}</span>
                                          </div>
                                          <div className="p-line"/>
                                      </div>
                                  </div>
                                )
                              } else {
                                  i++;
                                  if(i== 24)
                                      i=0;
                                  return (
                                    <div className="Items">
                                        <div className="Detail">
                                          <div className="mds">
                                                <span className="NO">{(y + 1) }</span>
                                                <span className="Barcode">{x.Barcode.length > 20 ? x.Barcode.substring(0, 20) + '...' : x.Barcode}</span>
                                                <span className="ProductType">{x.ProductType.length > 25 ? x.ProductType.substring(0, 25) + '...' : x.ProductType}</span>
                                                <span className="Category">{x.Category.length > 25 ? x.Category.substring(0, 25) + '...' : x.Category}</span>
                                                <span className="Brand">{x.Brand.length > 12 ? x.Brand.substring(0, 12) + '...' : x.Brand}</span>
                                                <span className="SizeType">{x.SizeType}</span>
                                                <span className="Size">{x.Size}</span>
                                                <span className="Retail_Price">{currencyFormat(x.Retail_Price)}</span>
                                            </div>
                                            <div className="ProductName">
                                              <span className="LaoName">{x.LaoName}</span>
                                              <span className="Quantity">{" (ຈຳນວນ " + x.Quantity + ")"}</span>
                                          </div>
                                          <div className="p-line"/>
                                        </div>
                                    </div>
                                  )
                              }
                              
                            })
                        }
                    </div>
                    <div className="ReportBodyFooter">
                      <span className="qQuatity">ຈຳນວນ:</span>
                      <span className="qty">{currencyFormat(TotalQTY)}</span>
                      <span className="Total">ຍອດເງິນລວມ:</span>
                      <span className="SubTotal">{currencyFormat(subtotal)}</span>
                    </div>
                    <div className="ReportSign">

                        <span className="Manager">ຜູ້ກວດກາ</span>
                        <span className="StockAdmin"></span>
                        <span className="finance">ຜູ້ຄິດໄລ່</span>
                    </div>
                </div>
            </div>
      );
  }
}


function StoreOrderReport() {

  function getDate(gdate) {
    const today = gdate;
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    return `${year}-${month}-${date} ${time}`;
  }
  const [StartedDate, setStartedDate] = useState(null); 
  const [EndedDate, setEndedDate] = useState(null); 
  const [LocationList, setLocationList] = useState(null); 
  const [LocationID, setLocationID] = useState(""); 
  const [LocationName, setLocationName] = useState("");
  const [ProductList, setProductList] = useState([]);
  const [ProductTypeList, setProductTypeList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [ProductTypeID, setProductTypeID] = useState(0);
  const [ProductType, setProductType] = useState(""); 
  const componentRef = useRef(); 

  const filterPassedTime = time => {
    const selectedDate = new Date(time);
    return selectedDate.getTime();
  }

  const handleChangeStartedDate = event => {
    if (event)
        setStartedDate(event);
    else 
        setStartedDate(null);
}

const handleChangeEndedDate = event => {
    if (event)
        setEndedDate(event);
    else 
        setEndedDate(null);
}

const handleSelectLocation = (e) => {
  var data = LocationList.filter(function (item) {
      return item.LocationName == e.target.value
  })
  if (data.length > 0) {
      setLocationName(data[0].LocationName);
      setLocationID(data[0].LocationID);
  } else {
      setLocationName("");
      setLocationID("");
  }
};

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  async function SearchTransaction() {
    console.log("test")
    await axios.get(`/StoreOrderReport/${getDate(StartedDate)}/${getDate(EndedDate)}/${LocationID}`).then((response) => {
      let Data = response?.data;
      console.log(Data)
      if(Data.length > 0){
        setShowData(Data);
      }else {
        setShowData([]);
      }
    }).catch((error) => {
      console.log(error);
    });
};

  useEffect(() => {
    let userData = localStorage.getItem("locationData");
    if (userData) {
      let userRole = JSON.parse(userData);
      setLocationList(userRole);
    }
  }, []);

  return (
      <div className="formContent">
        <div className="Header">
          <div className="title">
              <span>ລາຍງານຮ້ານເບີກເຄື່ອງ</span>
          </div>
          <div className="txtSearch">
          <div className="StartedDate">
                <label>ແຕ່ວັນທີ: </label>
                <DatePicker className="date"
                    selected={StartedDate}
                    onChange={(e) => handleChangeStartedDate(e)}
                    showTimeSelect
                    filterTime={filterPassedTime}
                    dateFormat="dd-MM-yyyy HH:mm"
                />
            </div>
            <div className="EndedDate">
                <label >ຫາວັນທີ: </label>
                <DatePicker className="date"
                    selected={EndedDate}
                    onChange={(e) => handleChangeEndedDate(e)}
                    showTimeSelect
                    filterTime={filterPassedTime}
                    dateFormat="dd-MM-yyyy HH:mm"
                />
            </div>
            <div className="Location">
                <label>ສາຂາ: </label>
                <select name="LocationID" onChange={(e) => handleSelectLocation(e)}
                    className={`input form-control`}>
                    <option
                        key={""}
                        value={""}
                    >
                        {'ເລືອກສາຂາ'}
                    </option>,
                    {LocationList && LocationList.map(item => (
                        <option
                            key={item.LocationID}
                            value={item.LocationName}
                        >
                            {item.LocationName}
                        </option>
                    ))}
                </select>
            </div>
            <button className="btnSearch btn btn-primary" onClick={() => SearchTransaction()}>
                ຄົ້ນຫາ
            </button>
            <button className="btnSearch btn btn-success" onClick={() => handlePrint()}>
                ພິມລາຍງານ
            </button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>Barcode</th>
                <th>ຊື່ ພາສາລາວ</th>
                <th>ຊື່ ພາສາອັງກິດ</th>
                <th>ປະເພດສິນຄ່້າ</th>
                <th>ໝວດສິນຄ້າ</th>
                <th>ຫຍີ່ຫໍ້</th>
                <th>ປະເພດຂະໜາດ</th>
                <th>ຂະໜາດ</th>
                <th>ລາຄາຊື້</th>
                <th>ລາຄາຂາຍ</th>
                <th>ຈຳນວນ</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.Barcode}</td>
                        <td >{x.LaoName }</td>
                        <td >{x.EngName}</td>
                        <td >{x.ProductType}</td>
                        <td >{x.Category}</td>
                        <td >{x.Brand}</td>
                        <td >{x.SizeType}</td>
                        <td >{x.Size}</td>
                        <td >{x.BuyPrice }</td>
                        <td >{x.Retail_Price}</td>
                        <td >{x.Quantity}</td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        <div style={{display: 'none'}}>
            <PrintReport ref={componentRef}
                    TemProductList={showData}
                    BillDetails={{"StartedDate": StartedDate, "EndedDate": EndedDate , "LocationName": LocationName}} 
            />
        </div>
      </div>
  );
};

export default StoreOrderReport;
